import { Link } from '@tanstack/react-router';
import { Fuel } from 'lucide-react';

import { CASA_DO_PARCEIRO_NA_MESA, ROTULO_DO_LANCAMENTO_DO_PARCEIRO } from '@/modulos/sessao/parceiro';

import { BotaoFechar } from '../Botao';
import { SimboloContrato } from '../Marca';

/**
 * O MENU DA PESSOA DE POSTO PARCEIRO (decisão 58, 0132): um item só, o
 * lançamento do abastecimento.
 *
 * Não é o trilho de sempre com um módulo: o trilho tem a busca de telas
 * (`Ctrl K`), o painel de cada módulo e os favoritos, e o recorte por
 * permissão deixaria passar as telas de leitura do combustível, que o papel
 * de parceiro tem para o formulário funcionar e o servidor recusa fora dele.
 * Este é o mesmo cartão flutuante (p.34), com as mesmas medidas, e nada além
 * do que a pessoa de posto pode abrir.
 */
export function NavegacaoDoParceiro({
  gavetaAberta = false,
  aoFecharGaveta,
}: {
  readonly gavetaAberta?: boolean;
  readonly aoFecharGaveta?: () => void;
}) {
  return (
    <>
      {gavetaAberta ? (
        <div
          aria-hidden
          className="fixed inset-0 z-[var(--z-gaveta)] hidden bg-sobreposicao max-[1024px]:block"
          onClick={aoFecharGaveta}
        />
      ) : null}
      <nav
        aria-label="Menu do posto parceiro"
        data-gaveta={gavetaAberta ? 'aberta' : 'fechada'}
        className="my-3 ml-3 flex w-[var(--menu-trilho-rotulos)] shrink-0 flex-col gap-3 overflow-hidden rounded-painel border border-borda-sutil bg-card py-3 shadow-superficie max-[1024px]:hidden data-[gaveta=aberta]:max-[1024px]:fixed data-[gaveta=aberta]:max-[1024px]:inset-y-0 data-[gaveta=aberta]:max-[1024px]:left-0 data-[gaveta=aberta]:max-[1024px]:z-[var(--z-gaveta)] data-[gaveta=aberta]:max-[1024px]:flex data-[gaveta=aberta]:max-[1024px]:anima-gaveta"
      >
        {gavetaAberta && aoFecharGaveta ? (
          <div className="flex justify-center">
            <BotaoFechar rotulo="Fechar o menu" aoFechar={aoFecharGaveta} />
          </div>
        ) : null}
        <div className="flex justify-center px-1">
          <SimboloContrato />
        </div>
        <ul className="flex flex-col gap-1 px-2">
          <li>
            <Link
              to={CASA_DO_PARCEIRO_NA_MESA}
              title={ROTULO_DO_LANCAMENTO_DO_PARCEIRO}
              onClick={aoFecharGaveta}
              className="flex w-full flex-col items-center gap-1 rounded-controle px-1 py-2 text-tinta-secundaria transition-colors hover:bg-rebaixada"
              activeProps={{ className: 'bg-selecao font-semibold text-tinta [&_svg]:text-marca', 'aria-current': 'page' }}
            >
              <Fuel aria-hidden="true" className="size-[var(--icone-menu)] shrink-0" />
              <span className="txt-linha2 w-full hyphens-auto text-center leading-tight text-pretty break-words">
                {ROTULO_DO_LANCAMENTO_DO_PARCEIRO}
              </span>
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
}
